


export interface StatisticCardData {
	id: string,
	label: string,
	tooltip?: string,
	value: number,
	maxValue?: number | null,
	volume?: number,
	percent?: number,
	state?: StatisticCardState,
}



export interface SimpleStatisticCardData {
	id: string,
	label: string,
	value: number,
	state?: StatisticCardState,
}



export enum StatisticCardState {
	danger = 'danger',
	warning = 'warning',
	success = 'success',
}